<template>
	<CEntryViewActions
		:statuses="statuses"
		:entries-selected="entriesSelected"
		:bulk-file-download-enabled="bulkFileDownloadEnabled"
		:can-manage-entries="globalStore.currentForm?.CanManageEntries"
		:limited-access="!globalStore.currentForm?.CanReviewEntries"
		:assigned-role="globalStore.currentView?.IsAssignedRole"
		:actions="actions"
		:view-id="globalStore.currentView?.Id"
		:role-name="roleName"
		:admin-api="adminApi"
		:user-info="userInfo"
		:role-id="globalStore.currentView?.RoleId"
		:selected-entries="selectedEntries"
		:has-paid-plan="globalStore.organization.Plan.IsPaidPlan"
		:view-token="globalStore.currentView?.Token"
		bulk-document-download-enabled
		:is-popper-mode="isPopperMode"
		:document-templates="documentTemplates"
		:disable-unread-entry-tracking="globalStore.organization.DisableUnreadEntryTracking"
		display-limited-access-multi-button
		:entry-details-open="entryDetailsOpen"
		:is-mobile="isMobile"
		@export="handleExport"
		@bulk-action="handleAction"
	/>
</template>

<script lang="ts">
	import type { PropType } from 'vue';
	import { defineComponent, computed } from 'vue';
	import CEntryViewActions from 'src/views/entries/EntryViewActions.vue';
	import type { GlobalStore } from 'src/stores/global-store';
	import type { UserInfo } from '@cognitoforms/types/server-types/forms/model/user-info';

	export default defineComponent({
		name: 'CEntryViewActionsContainer',
		components: {
			CEntryViewActions
		},
		props: {
			globalStore: {
				type: Object as PropType<GlobalStore>,
				required: true
			},
			roleName: {
				type: String,
				required: true
			},
			entriesSelected: {
				type: Boolean,
				default: false
			},
			isPopperMode: {
				type: Boolean,
				default: false
			},
			adminApi: {
				type: Object,
				default: null
			},
			isMobile: {
				type: Boolean,
				default: false
			}
		},
		emits: ['export', 'bulk-action'],
		setup(props, { emit }) {
			const actions = computed(() => (window as any).Cognito?.Forms?.model.currentForm?.get_workflowActionsList());
			const statuses = computed(() => {
				const filteredStatuses = (window as any).Cognito?.Forms?.model.currentForm?._EntryStatuses.filter(f => f._IsArchived === false);
				return (window as any).Cognito?.serialize(filteredStatuses);
			});

			const documentTemplates = computed(() => (window as any).Cognito?.Forms?.model.currentForm?.documentTemplates);
			const entryDetailsOpen = computed(() => (window as any).Cognito?.Forms?.model.currentForm?.entryDetailsOpen);
			const bulkFileDownloadEnabled = computed(() => (window as any).Cognito?.Forms?.model.bulkFileDownloadEnabled);
			const selectedEntries = computed(() => (window as any).Cognito?.Forms?.model.currentForm?._selectedEntries);
			const userInfo = computed<UserInfo>(() => {
				return {
					Name: props.globalStore.fullName,
					FirstName: props.globalStore.user.FirstName,
					LastName: props.globalStore.user.LastName,
					Email: props.globalStore.user.Email
				};
			});

			const handleExport = () => {
				emit('export', false, selectedEntries.value);
			};

			const handleAction = (action) => {
				emit('bulk-action', action);
			};

			return {
				actions,
				statuses,
				documentTemplates,
				entryDetailsOpen,
				bulkFileDownloadEnabled,
				selectedEntries,
				userInfo,
				handleExport,
				handleAction
			};
		}

	});
</script>
